import { Chip, Tooltip, Typography } from '@mui/material';
import { UnwindOrderState } from '../../hooks/useUnwindingSocket';

const stateChipColor = (
  state: string
): 'default' | 'success' | 'warning' | 'error' | 'info' => {
  switch (state) {
    case 'idle':
      return 'default';
    case 'maker_resting':
      return 'info';
    case 'maker_placing':
    case 'maker_adjusting':
    case 'maker_cancelling':
    case 'counter_checking':
    case 'counter_taker_executing':
    case 'counter_maker_resting':
      return 'warning';
    case 'execution_complete':
      return 'success';
    case 'error':
      return 'error';
    default:
      return 'default';
  }
};

const formatState = (state: string) => state.replace(/_/g, ' ');

interface LiveStatusIndicatorProps {
  liveState?: UnwindOrderState;
}

export const LiveStatusIndicator = ({ liveState }: LiveStatusIndicatorProps) => {
  if (!liveState) {
    return (
      <Typography sx={{ fontSize: '0.7rem', color: 'grey.600' }}>
        —
      </Typography>
    );
  }

  return (
    <Tooltip
      title={
        liveState.makerOrderId
          ? `Order: ${liveState.makerOrderId.slice(0, 8)}... @ ${liveState.makerPrice ?? '—'}`
          : liveState.errorMessage || ''
      }
    >
      <Chip
        label={formatState(liveState.state)}
        size="small"
        color={stateChipColor(liveState.state)}
        sx={{
          fontSize: '0.6rem',
          fontWeight: 600,
          height: 18,
          borderRadius: '4px',
          textTransform: 'capitalize'
        }}
      />
    </Tooltip>
  );
};
